{
  "common": {
    "loading": "Đang tải...",
    "cancel": "Huỷ",
    "close": "Đóng",
    "update": "Cập nhật",
    "create": "Tạo",
    "confirm": "Xác nhận",
    "processing": "Đang xử lý...",
    "yes": "Có",
    "no": "Không",
    "unknown": "Không xác định",
    "actionFailed": "Thao tác thất bại"
  },
  "tierLabels": {
    "starter": "Starter",
    "silver": "Silver",
    "gold": "Gold",
    "platinum": "Platinum"
  },
  "statusLabels": {
    "active": "Đang hoạt động",
    "paused": "Tạm dừng",
    "banned": "Đã chặn"
  },
  "kycLabels": {
    "pending": "Chưa nộp",
    "submitted": "Chờ duyệt",
    "verified": "Đã xác minh",
    "rejected": "Từ chối"
  },
  "payoutStatusLabels": {
    "requested": "Chờ duyệt",
    "approved": "Đã duyệt",
    "paid": "Đã chi trả",
    "rejected": "Từ chối"
  },
  "reasonLabels": {
    "ip_reuse": "Trùng IP",
    "velocity": "Tần suất bất thường",
    "ua_anomaly": "User-Agent lạ",
    "manual": "Báo cáo thủ công"
  },
  "commissionStatusLabels": {
    "pending": "Chờ xử lý",
    "locked": "Đã khoá",
    "paid": "Đã chi trả",
    "refunded": "Đã hoàn"
  },
  "kycDocKinds": {
    "id_front": "CMND/CCCD mặt trước",
    "id_back": "CMND/CCCD mặt sau",
    "selfie": "Ảnh selfie",
    "address_proof": "Giấy tờ địa chỉ"
  },
  "hub": {
    "heading": "Quản lý Affiliate",
    "subtitle": "Danh sách Affiliate, hàng đợi chi trả, báo cáo gian lận và ShortLinks toàn hệ thống.",
    "tabsAria": "Tab quản lý Affiliate",
    "panelAria": "Bảng {{tab}}",
    "tabs": {
      "list": "Danh sách Affiliate",
      "payouts": "Hàng đợi chi trả",
      "abuse": "Báo cáo gian lận",
      "shortlinks": "ShortLinks"
    }
  },
  "list": {
    "heading": "Danh sách Affiliate",
    "subtitle": "Danh sách affiliate — lọc theo trạng thái, tier, KYC.",
    "searchPlaceholder": "Tìm theo handle hoặc email...",
    "filters": {
      "allTiers": "Tất cả tier",
      "tierOption": "Tier: {{label}}",
      "allStatuses": "Tất cả trạng thái",
      "allKyc": "Tất cả KYC",
      "kycOption": "KYC: {{label}}"
    },
    "columns": {
      "handle": "Handle",
      "tier": "Tier",
      "status": "Trạng thái",
      "kyc": "KYC",
      "commissionMtd": "Hoa hồng tháng",
      "clicks": "Click",
      "conversions": "Conversion",
      "lastActive": "Hoạt động cuối"
    },
    "empty": "Chưa có affiliate nào khớp bộ lọc."
  },
  "detail": {
    "loadError": "Không tải được thông tin affiliate.",
    "tierBadge": "Tier: {{label}}",
    "kycBadge": "KYC: {{label}}",
    "tabs": {
      "profile": "Hồ sơ",
      "kyc": "KYC",
      "commissions": "Hoa hồng",
      "clicks": "Clicks",
      "payouts": "Lịch sử chi trả"
    },
    "actions": {
      "suspend": "Tạm dừng",
      "changeTier": "Đổi tier",
      "forcePayout": "Chi trả thủ công",
      "whitelist": "Whitelist IP"
    },
    "success": {
      "suspend": "Đã tạm dừng affiliate.",
      "changeTier": "Đã đổi tier.",
      "forcePayout": "Đã tạo yêu cầu chi trả.",
      "whitelist": "Đã cập nhật danh sách IP."
    },
    "errors": {
      "suspend": "Tạm dừng thất bại.",
      "changeTier": "Đổi tier thất bại.",
      "forcePayout": "Tạo chi trả thất bại.",
      "whitelist": "Cập nhật IP thất bại."
    },
    "suspendForm": {
      "title": "Tạm dừng affiliate",
      "reasonPlaceholder": "Lý do tạm dừng..."
    },
    "tierForm": {
      "title": "Đổi tier",
      "reasonPlaceholder": "Lý do đổi tier..."
    },
    "forcePayoutForm": {
      "title": "Chi trả thủ công",
      "amountLabel": "Số tiền (USD)",
      "reasonPlaceholder": "Lý do..."
    },
    "whitelistForm": {
      "title": "Whitelist IP",
      "empty": "Chưa có IP nào được whitelist.",
      "add": "Thêm",
      "remove": "Xoá"
    },
    "profile": {
      "email": "Email",
      "fullName": "Họ tên",
      "createdAt": "Tạo lúc",
      "lastActive": "Hoạt động cuối",
      "whitelistedIps": "IP được whitelist"
    },
    "kyc": {
      "empty": "Affiliate chưa nộp tài liệu KYC.",
      "viewDoc": "Xem tài liệu",
      "uploadedAt": "Tải lên: {{date}}"
    },
    "commissions": {
      "empty": "Chưa có hoa hồng.",
      "columns": {
        "order": "Đơn",
        "amount": "Số tiền",
        "status": "Trạng thái",
        "earned": "Ghi nhận lúc",
        "locked": "Khoá lúc",
        "paid": "Trả lúc"
      }
    },
    "clicks": {
      "empty": "Chưa có click nào.",
      "columns": {
        "slug": "Slug",
        "ip": "IP",
        "bot": "Bot?",
        "when": "Thời điểm",
        "converted": "Đơn chuyển đổi"
      }
    },
    "payoutsHistory": {
      "empty": "Chưa có lịch sử chi trả.",
      "columns": {
        "id": "Mã",
        "amount": "Số tiền",
        "status": "Trạng thái",
        "requested": "Yêu cầu",
        "approved": "Duyệt",
        "paid": "Chi trả"
      }
    }
  },
  "payouts": {
    "heading": "Hàng đợi chi trả",
    "subtitle": "Duyệt / từ chối / đánh dấu đã chi các yêu cầu rút tiền của affiliate.",
    "filters": {
      "allStatuses": "Tất cả trạng thái",
      "affiliateIdPlaceholder": "Affiliate ID...",
      "minAmount": "Tối thiểu $"
    },
    "bulkMarkPaid": "Đánh dấu đã chi hàng loạt ({{count}})",
    "columns": {
      "affiliate": "Affiliate",
      "amount": "Số tiền",
      "status": "Trạng thái",
      "requestedAt": "Yêu cầu lúc",
      "banking": "Banking",
      "actions": "Thao tác"
    },
    "empty": "Không có payout nào khớp bộ lọc.",
    "rowActions": {
      "approve": "Duyệt",
      "reject": "Từ chối",
      "markPaid": "Đánh dấu đã chi"
    },
    "errors": {
      "approve": "Duyệt payout thất bại.",
      "markPaid": "Đánh dấu thất bại.",
      "reject": "Từ chối payout thất bại."
    },
    "toast": {
      "approveSuccess": "Thao tác thành công.",
      "markPaidSuccess": "Đã đánh dấu đã chi trả.",
      "rejectSuccess": "Đã từ chối payout.",
      "bulkSuccess": "Đã chi trả {{count}} payout.",
      "bulkPartial": "Hoàn tất {{ok}}, thất bại {{failed}}."
    },
    "approveDrawer": {
      "title": "Duyệt payout",
      "commentLabel": "Ghi chú (tuỳ chọn)"
    },
    "rejectDrawer": {
      "title": "Từ chối payout",
      "reasonLabel": "Lý do từ chối"
    },
    "markPaidDrawer": {
      "title": "Đánh dấu đã chi trả",
      "bulkTitle": "Đánh dấu đã chi hàng loạt ({{count}})",
      "bulkNote": "Áp dụng cho {{count}} payout đã chọn.",
      "bankRefLabel": "Bank reference",
      "paidAtLabel": "Thời điểm chi trả",
      "proofLabel": "URL chứng từ (tuỳ chọn)",
      "grossLabel": "Gross (USD)",
      "withholdLabel": "Khấu trừ (USD)"
    }
  },
  "abuse": {
    "heading": "Báo cáo gian lận",
    "subtitle": "Báo cáo lạm dụng affiliate (click fraud, self-referral).",
    "filters": {
      "allReasons": "Tất cả lý do",
      "affiliateIdPlaceholder": "Affiliate ID..."
    },
    "columns": {
      "affiliate": "Affiliate",
      "reason": "Lý do",
      "flaggedAt": "Flagged lúc",
      "botHuman": "Bot / Human (24h)",
      "conversion": "Conversion",
      "actions": "Thao tác"
    },
    "empty": "Không có báo cáo nào khớp bộ lọc.",
    "rowActions": {
      "whitelist": "Whitelist",
      "suspend": "Tạm dừng"
    },
    "errors": {
      "suspend": "Tạm dừng thất bại.",
      "whitelist": "Cập nhật whitelist thất bại."
    },
    "toast": {
      "suspendSuccess": "Đã tạm dừng affiliate.",
      "whitelistSuccess": "Đã cập nhật whitelist."
    },
    "whitelistDialog": {
      "title": "Whitelist IP cho @{{handle}}",
      "descPrefix": "Bỏ qua flag và đánh dấu IP là hợp lệ. Hành động này thêm IP vào",
      "descSuffix": "của affiliate (D-GA-10)."
    }
  },
  "shortlinks": {
    "heading": "Short Links",
    "subtitle": "Quản lý branded short-link của affiliate + analytics.",
    "filters": {
      "searchPlaceholder": "Tìm theo slug hoặc URL đích...",
      "affiliateIdPlaceholder": "Affiliate ID...",
      "allBanned": "Tất cả",
      "banned": "Đã ban",
      "active": "Còn hoạt động"
    },
    "columns": {
      "slug": "Slug",
      "affiliate": "Affiliate",
      "targetUrl": "URL đích",
      "clicks": "Click",
      "conversions": "Conversion",
      "status": "Trạng thái",
      "actions": "Thao tác"
    },
    "empty": "Không có ShortLink nào khớp bộ lọc.",
    "bannedAt": "Đã ban: {{date}}",
    "statusActive": "Hoạt động",
    "rowActions": {
      "ban": "Ban"
    },
    "errors": {
      "ban": "Ban thất bại."
    },
    "toast": {
      "banSuccess": "Đã ban ShortLink."
    },
    "banDialog": {
      "title": "Ban ShortLink /r/{{slug}}",
      "desc": "Hành động này soft-delete ShortLink. Mọi resolve sau đó trả 410 Gone. Ghi rõ lý do để audit log có context.",
      "reasonLabel": "Lý do"
    }
  }
}
